webpackJsonp([102],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/hotel.json": [
		115,
		10
	],
	"./ja/hotel.json": [
		116,
		9
	],
	"./ko/hotel.json": [
		117,
		8
	],
	"./zh-CN/hotel.json": [
		118,
		7
	],
	"./zh-TW/hotel.json": [
		119,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 10;

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(16);
__webpack_require__(6);
__webpack_require__(5);

__webpack_require__(101);

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Vue) {

var init = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var text, moment, login, OwlCarousel, parsley, validator, moreListPanels$;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 8));

                    case 2:
                        _context.next = 4;
                        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 12));

                    case 4:
                        _context.next = 6;
                        return __webpack_require__(10)("./" + locale + '/hotel.json');

                    case 6:
                        text = _context.sent;
                        _context.next = 9;
                        return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 22));

                    case 9:
                        moment = _context.sent;
                        _context.next = 12;
                        return __webpack_require__.e/* import() */(80/* duplicate */).then(__webpack_require__.bind(null, 134));

                    case 12:
                        login = _context.sent;
                        _context.next = 15;
                        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 11));

                    case 15:
                        OwlCarousel = _context.sent;
                        _context.next = 18;
                        return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 23));

                    case 18:
                        parsley = _context.sent;


                        //對使用者輸入的折價券內容進行檢查
                        $('#discount-code-text').attr({
                            'data-parsley-required': true,
                            'data-parsley-pattern': '[A-Za-z0-9]+',
                            'data-parsley-pattern-message': '僅可英文數字組合'
                        });

                        validator = parsley.$element.find('#discount-code-form').parsley({
                            errorsWrapper: '<div></div>',
                            errorTemplate: '<span class="color-red" style="font-size: 10pt; color: #e74c3c;"></span>',
                            errorsContainer: function errorsContainer(field) {
                                return field.$element.closest('div').find('div.error-message');
                            }
                        });


                        $('#discount-code-form-submit').bind('click', function (event) {
                            validator.validate();
                            if (validator.isValid()) {
                                $('#discount-code-form').submit();
                            }
                        });

                        //在折價券列表中，顯示隱藏的文字內容
                        $('.readmore').click(function (event) {
                            var that$ = $(this);
                            that$.closest('div.text-content').find('div.texthide').removeClass('texthide').addClass('showmore').end().find('div.overtext').remove();
                            that$.remove();
                        });

                        $(document).ready(function () {
                            OwlCarousel.initOwlCarousel();
                        });

                        /**套裝資料*/
                        //判斷套裝內容是否要打開或折疊
                        moreListPanels$ = $('.panel-collapse');

                        moreListPanels$.on('shown.bs.collapse', function () {
                            var toggleButton = $('div.morelist[href="#' + this.id + '"]');
                            if (typeof toggleButton.get(0).scrollIntoView === 'function') {
                                toggleButton.get(0).scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                            toggleButton.trigger('changeMoreListText');
                        });
                        moreListPanels$.on('hidden.bs.collapse', function () {
                            var toggleButton = $('div.morelist[href="#' + this.id + '"]');
                            toggleButton.trigger('changeMoreListText');
                        });

                        //打開或折疊套裝內容
                        $('.morelist').on('changeMoreListText', function () {
                            var collapse = $(this).attr('href');
                            var collapse$ = $(collapse);
                            var isOpen = collapse$.hasClass('in');

                            if (isOpen === true) {
                                $(this).find('.show-promotion-list').hide();
                                $(this).find('.hidden-promotion-list').show();
                            } else {
                                $(this).find('.hidden-promotion-list').hide();
                                $(this).find('.show-promotion-list').show();
                            }
                        });

                        $(function () {
                            function fetchInventory(cb) {
                                var that = this;
                                that.isLoading = true;
                                that.checkInDate = '';
                                $.ajax(urlPrefix + '/discount/promotionInventory/' + promotionNo, {
                                    type: 'POST',
                                    headers: {
                                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                    },
                                    data: {
                                        'start-date': that.startDay.format('YYYY-MM-DD'),
                                        'end-date': that.endDay.format('YYYY-MM-DD'),
                                        'room-qty': that.roomQty,
                                        'nights': that.nights,
                                        'is-channel': that.isChannel,
                                        'discount': discountNo
                                    },
                                    dataType: 'json',
                                    success: function success(res) {
                                        if (true === res.status) {
                                            if (true === res.waiting) {
                                                that.waiting_on = res.waiting;
                                            }
                                            var row = that.calendarRow;
                                            var inventory = [];
                                            var inventoryWeek;
                                            for (var i = 0; i <= row; i++) {
                                                inventoryWeek = [];
                                                for (var j = 7 * i; j < 7 * (i + 1); j++) {
                                                    if (j < that.calendar.firstDateDay) {
                                                        inventoryWeek.push({
                                                            current: false
                                                        });
                                                    } else if (j - that.calendar.firstDateDay >= that.calendar.endDate) {
                                                        inventoryWeek.push({
                                                            current: false
                                                        });
                                                    } else {
                                                        inventoryWeek.push({
                                                            date: moment(res.inventory[j - that.calendar.firstDateDay].date),
                                                            price: res.inventory[j - that.calendar.firstDateDay].price,
                                                            qty: res.inventory[j - that.calendar.firstDateDay].qty,
                                                            available: res.inventory[j - that.calendar.firstDateDay].available,
                                                            applicable: res.inventory[j - that.calendar.firstDateDay].applicable,
                                                            isAfter: moment(res.inventory[j - that.calendar.firstDateDay].date).isSameOrAfter(moment().format('YYYY-MM-DD'), 'day'),
                                                            current: true,
                                                            discountPrice: res.inventory[j - that.calendar.firstDateDay].discountPrice,
                                                            discountExpired: res.inventory[j - that.calendar.firstDateDay].discountExpired
                                                        });
                                                    }
                                                }
                                                inventory.push(inventoryWeek);
                                            }
                                            that.inventory = inventory;
                                        } else {
                                            alert(res.message);
                                            cb();
                                        }
                                        that.isLoading = false;
                                    }
                                });
                            }

                            if (document.getElementById('vue-discount-promotion') !== null) {
                                var today = moment();
                                var firstDay = Date.parse(startDay).valueOf() > Date.parse(discountStartDay).valueOf() ? moment(startDay) : moment(discountStartDay);
                                var calendarInitDate = today.isBefore(moment(firstDay)) ? moment(firstDay) : today;

                                var vm = new Vue({
                                    el: '#vue-discount-promotion',
                                    data: {
                                        nights: nights,
                                        isChannel: isChannel,
                                        roomQty: 1,
                                        calendar: {
                                            today: today,
                                            year: calendarInitDate.year(),
                                            month: calendarInitDate.month() + 1,
                                            firstDateDay: calendarInitDate.startOf('month').day(),
                                            endDate: calendarInitDate.endOf('month').date()
                                        },
                                        waiting_on: false,
                                        inventory: [],
                                        checkInDate: '',
                                        isWaiting: 0,
                                        isLoading: false,
                                        nextLoading: false
                                    },
                                    created: function created() {
                                        // 先抓取第一個月份的庫存
                                        fetchInventory.call(this);
                                    },
                                    computed: {
                                        startDay: function (_startDay) {
                                            function startDay() {
                                                return _startDay.apply(this, arguments);
                                            }

                                            startDay.toString = function () {
                                                return _startDay.toString();
                                            };

                                            return startDay;
                                        }(function () {
                                            var calendarStart = Date.parse(startDay).valueOf() > Date.parse(discountStartDay).valueOf() ? moment(startDay) : moment(discountStartDay);
                                            if (calendarStart.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')) {
                                                return calendarStart;
                                            } else {
                                                return moment([this.calendar.year, this.calendar.month - 1]).startOf('month');
                                            }
                                        }),
                                        endDay: function (_endDay) {
                                            function endDay() {
                                                return _endDay.apply(this, arguments);
                                            }

                                            endDay.toString = function () {
                                                return _endDay.toString();
                                            };

                                            return endDay;
                                        }(function () {
                                            var calendarEnd = moment(endDay);
                                            if (calendarEnd.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')) {
                                                return calendarEnd;
                                            } else {
                                                return moment([this.calendar.year, this.calendar.month - 1]).endOf('month');
                                            }
                                        }),
                                        calendarRow: function calendarRow() {
                                            return Math.ceil((this.calendar.endDate + this.calendar.firstDateDay) / 7) - 1;
                                        },
                                        currentMonth: function currentMonth() {
                                            return this.calendar.today.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month');
                                        },
                                        checkInDateSend: function checkInDateSend() {
                                            if (this.checkInDate instanceof moment) {
                                                return this.checkInDate.format('YYYY-MM-DD');
                                            }
                                            return '';
                                        },
                                        checkNextMonth: function checkNextMonth() {
                                            var right = this.calendar.month == 12 ? String(this.calendar.year + 1) + "-01-01" : String(this.calendar.year) + "-" + String(this.calendar.month + 1) + "-01";
                                            return Date.parse(right).valueOf() > Date.parse(discountEndDay).valueOf() ? false : true;
                                        },
                                        checkLeftMonth: function checkLeftMonth() {
                                            switch (this.calendar.month) {
                                                case 1:
                                                    var left = String(this.calendar.year - 1) + "-12-31";
                                                    break;
                                                case 2:case 4:case 6:case 8:case 9:
                                                    var left = String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-31";
                                                    break;
                                                case 3:
                                                    var left = this.calendar.year % 4 == 0 ? String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-29" : String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-28";
                                                    break;
                                                case 5:case 7:case 10:
                                                    var left = String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-30";
                                                    break;
                                                case 11:
                                                    var left = String(this.calendar.year) + "-" + String(this.calendar.month - 1) + "-31";
                                                    break;
                                                case 12:
                                                    var left = String(this.calendar.year) + "-" + String(this.calendar.month - 1) + "-30";
                                                    break;
                                            }
                                            return Date.parse(left).valueOf() < Date.parse(firstDay).valueOf() ? false : true;
                                        }
                                    },
                                    methods: {
                                        prev: function prev() {
                                            var changeDate = moment([this.calendar.year, this.calendar.month - 1]).subtract(1, 'months');
                                            if (changeDate.isSameOrAfter(moment().format('YYYY-MM-DD'), 'month')) {
                                                this.calendar.year = changeDate.year();
                                                this.calendar.month = changeDate.month() + 1;
                                                this.calendar.firstDateDay = changeDate.startOf('month').day();
                                                this.calendar.endDate = changeDate.endOf('month').date();
                                                fetchInventory.call(this, this.next);
                                            } else {
                                                alert(text.SystemText.NotFurther);
                                            }
                                        },
                                        next: function next() {
                                            var changeDate = moment([this.calendar.year, this.calendar.month - 1]).add(1, 'months');
                                            this.calendar.year = changeDate.year();
                                            this.calendar.month = changeDate.month() + 1;
                                            this.calendar.firstDateDay = changeDate.startOf('month').day();
                                            this.calendar.endDate = changeDate.endOf('month').date();
                                            fetchInventory.call(this, this.prev);
                                        },
                                        selectRoomQty: function selectRoomQty() {
                                            this.checkInDate = '';
                                            fetchInventory.call(this, function () {});
                                        },
                                        selectNights: function selectNights() {
                                            this.checkInDate = '';
                                            fetchInventory.call(this, function () {});
                                        },
                                        selectCheckInDate: function selectCheckInDate(date, isWaiting, event) {
                                            var this$ = $(event.target).closest('a');
                                            this$.focus();
                                            this.checkInDate = date;
                                            this.isWaiting = isWaiting || 0;
                                        },
                                        backList: function backList() {
                                            window.location = urlPrefix + '/' + hotelId + '/discount/' + discountCode;
                                        },
                                        submitNext: function submitNext(event) {
                                            var that = this;
                                            if (that.checkInDate instanceof moment) {
                                                that.nextLoading = true;
                                                var form$ = $('#promotion-submit-form');
                                                login.check(function (err, status, userInfo) {
                                                    if (status === true) {
                                                        form$.submit();
                                                    } else {
                                                        that.nextLoading = false;
                                                        login.initModal($(event.target), function (target) {
                                                            that.nextLoading = true;
                                                            form$.submit();
                                                        }, !!that.isWaiting);
                                                    }
                                                });
                                            } else {
                                                alert(text.SystemText.SelectDate);
                                            }
                                        }
                                    }
                                });
                            }
                        });

                        /**一般訂房處理*/
                        $(function () {
                            $('#change-room').change(function (event) {
                                //房型庫存頁面切換房型
                                window.location = urlPrefix + '/room/' + $("#change-room").val();
                            });

                            function fetchRoomInventory(cb) {
                                var that = this;

                                that.isLoading = true;
                                that.checkInDate = '';
                                $.ajax(urlPrefix + '/discount/roomInventory/' + roomNo, {
                                    type: 'POST',
                                    headers: {
                                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                    },
                                    data: {
                                        'year': that.calendar.year,
                                        'month': that.calendar.month,
                                        'room-qty': that.roomQty,
                                        'nights': that.nights,
                                        'discount': discountNo
                                    },
                                    dataType: 'json',
                                    success: function success(res) {
                                        if (true === res.status) {
                                            if (true === res.waiting) {
                                                that.waiting_on = res.waiting;
                                            }
                                            var row = that.calendarRow;
                                            var inventory = [];
                                            var inventoryWeek = void 0;
                                            for (var i = 0; i <= row; i++) {
                                                inventoryWeek = [];
                                                for (var j = 7 * i; j < 7 * (i + 1); j++) {
                                                    if (j < that.calendar.firstDateDay) {
                                                        inventoryWeek.push({
                                                            current: false
                                                        });
                                                    } else if (j - that.calendar.firstDateDay >= that.calendar.endDate) {
                                                        inventoryWeek.push({
                                                            current: false
                                                        });
                                                    } else {
                                                        inventoryWeek.push({
                                                            date: moment(res.inventory[j - that.calendar.firstDateDay].date),
                                                            price: res.inventory[j - that.calendar.firstDateDay].price,
                                                            qty: res.inventory[j - that.calendar.firstDateDay].qty,
                                                            available: res.inventory[j - that.calendar.firstDateDay].available,
                                                            applicable: res.inventory[j - that.calendar.firstDateDay].applicable,
                                                            isAfter: moment(res.inventory[j - that.calendar.firstDateDay].date).isSameOrAfter(moment().format('YYYY-MM-DD'), 'day'),
                                                            current: true,
                                                            discountPrice: res.inventory[j - that.calendar.firstDateDay].discountPrice,
                                                            discountExpired: res.inventory[j - that.calendar.firstDateDay].discountExpired
                                                        });
                                                    }
                                                }
                                                inventory.push(inventoryWeek);
                                            }
                                            that.inventory = inventory;
                                        } else {
                                            alert(res.message);
                                            cb();
                                        }
                                        that.isLoading = false;
                                    }
                                });
                            }

                            if (document.getElementById('vue-discount-room') !== null) {
                                var firstDay = moment(firstSaleDay);
                                var calendarInitDate = firstDay.isBefore(moment(startDay)) ? moment(startDay) : firstDay;

                                var vm = new Vue({
                                    el: '#vue-discount-room',
                                    data: {
                                        nights: 1,
                                        roomQty: 1,
                                        calendar: {
                                            firstDay: firstDay,
                                            year: calendarInitDate.year(),
                                            month: calendarInitDate.month() + 1,
                                            firstDateDay: calendarInitDate.startOf('month').day(),
                                            endDate: calendarInitDate.endOf('month').date()
                                        },
                                        waiting_on: false,
                                        inventory: [],
                                        checkInDate: '',
                                        isWaiting: 0,
                                        isLoading: false,
                                        nextLoading: false
                                    },
                                    created: function created() {
                                        // 先抓取第一個月份的庫存
                                        fetchRoomInventory.call(this);
                                    },
                                    computed: {
                                        startDay: function (_startDay2) {
                                            function startDay() {
                                                return _startDay2.apply(this, arguments);
                                            }

                                            startDay.toString = function () {
                                                return _startDay2.toString();
                                            };

                                            return startDay;
                                        }(function () {
                                            var calendarStart = moment(startDay);
                                            if (calendarStart.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')) {
                                                return calendarStart;
                                            } else {
                                                return moment([this.calendar.year, this.calendar.month - 1]).startOf('month');
                                            }
                                        }),
                                        endDay: function (_endDay2) {
                                            function endDay() {
                                                return _endDay2.apply(this, arguments);
                                            }

                                            endDay.toString = function () {
                                                return _endDay2.toString();
                                            };

                                            return endDay;
                                        }(function () {
                                            var calendarEnd = moment(endDay);
                                            if (calendarEnd.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')) {
                                                return calendarEnd;
                                            } else {
                                                return moment([this.calendar.year, this.calendar.month - 1]).endOf('month');
                                            }
                                        }),
                                        calendarRow: function calendarRow() {
                                            return Math.ceil((this.calendar.endDate + this.calendar.firstDateDay) / 7) - 1;
                                        },
                                        currentMonth: function currentMonth() {
                                            return this.calendar.firstDay.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month');
                                        },
                                        checkInDateSend: function checkInDateSend() {
                                            if (this.checkInDate instanceof moment) {
                                                return this.checkInDate.format('YYYY-MM-DD');
                                            }
                                            return '';
                                        },
                                        checkNextMonth: function checkNextMonth() {
                                            var right = this.calendar.month == 12 ? String(this.calendar.year + 1) + "-01-01" : String(this.calendar.year) + "-" + String(this.calendar.month + 1) + "-01";
                                            return Date.parse(right).valueOf() > Date.parse(discountEndDay).valueOf() ? false : true;
                                        },
                                        checkLeftMonth: function checkLeftMonth() {
                                            switch (this.calendar.month) {
                                                case 1:
                                                    var left = String(this.calendar.year - 1) + "-12-31";
                                                    break;
                                                case 2:case 4:case 6:case 8:case 9:
                                                    var left = String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-31";
                                                    break;
                                                case 3:
                                                    var left = this.calendar.year % 4 == 0 ? String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-29" : String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-28";
                                                    break;
                                                case 5:case 7:case 10:
                                                    var left = String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-30";
                                                    break;
                                                case 11:
                                                    var left = String(this.calendar.year) + "-" + String(this.calendar.month - 1) + "-31";
                                                    break;
                                                case 12:
                                                    var left = String(this.calendar.year) + "-" + String(this.calendar.month - 1) + "-30";
                                                    break;
                                            }
                                            return Date.parse(left).valueOf() < Date.parse(discountStartDay).valueOf() ? false : true;
                                        }
                                    },
                                    methods: {
                                        prev: function prev() {
                                            var changeDate = moment([this.calendar.year, this.calendar.month - 1]).subtract(1, 'months');
                                            if (changeDate.isSameOrAfter(moment().format('YYYY-MM-DD'), 'month')) {
                                                this.calendar.year = changeDate.year();
                                                this.calendar.month = changeDate.month() + 1;
                                                this.calendar.firstDateDay = changeDate.startOf('month').day();
                                                this.calendar.endDate = changeDate.endOf('month').date();
                                                fetchRoomInventory.call(this, this.next);
                                            } else {
                                                alert(text.SystemText.NotFurther);
                                            }
                                        },
                                        next: function next() {
                                            var changeDate = moment([this.calendar.year, this.calendar.month - 1]).add(1, 'months');
                                            this.calendar.year = changeDate.year();
                                            this.calendar.month = changeDate.month() + 1;
                                            this.calendar.firstDateDay = changeDate.startOf('month').day();
                                            this.calendar.endDate = changeDate.endOf('month').date();
                                            fetchRoomInventory.call(this, this.prev);
                                        },
                                        selectRoomQty: function selectRoomQty() {
                                            this.checkInDate = '';
                                            fetchRoomInventory.call(this, function () {});
                                        },
                                        selectNights: function selectNights() {
                                            this.checkInDate = '';
                                            fetchRoomInventory.call(this, function () {});
                                        },
                                        selectCheckInDate: function selectCheckInDate(date, isWaiting, event) {
                                            var this$ = $(event.target).closest('a');
                                            this$.focus();
                                            this.checkInDate = date;
                                            this.isWaiting = isWaiting || 0;
                                        },
                                        backList: function backList() {
                                            window.location = urlPrefix + '/' + hotelId + '/discount/' + discountCode;
                                        },
                                        submitNext: function submitNext(event) {
                                            var that = this;
                                            if (that.checkInDate instanceof moment) {
                                                that.nextLoading = true;
                                                var form$ = $('#room-submit-form');
                                                login.check(function (err, status, userInfo) {
                                                    if (status === true) {
                                                        form$.submit();
                                                    } else {
                                                        that.nextLoading = false;
                                                        login.initModal($(event.target), function (target) {
                                                            that.nextLoading = true;
                                                            form$.submit();
                                                        }, !!that.isWaiting);
                                                    }
                                                });
                                            } else {
                                                alert(text.SystemText.SelectDate);
                                            }
                                        }
                                    }
                                });
                            }
                        });

                    case 30:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function init() {
        return _ref.apply(this, arguments);
    };
}();

__webpack_require__(234);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

init();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(108)))

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[264]);


// WEBPACK FOOTER //
// js/build/discount-be7f0c596fa4b6811a0f.js